import { ACTIONS } from "../../../Models/ENUM";
import ARRAY from "../../../UTIL/ARRAY";
import CONQUER from "../../CONQUER";
import GameInstance from "../GameInstance";
import MATH from "../../../UTIL/MATH";
import RANDOM from "../../../UTIL/RANDOM";
import LOG, { log } from "../../../UTIL/LOG";
import ScoreboardInstance from "./ScoreboardInstance";
import DATE from "../../../UTIL/DATE";

class Scoreboard
{
    private conquer         : CONQUER;
    private query           : any;
    private gameInstance    : GameInstance;

    private ladder          : any;
    private ladderLength    : number = 0;

    public pool             : any = [];

    public current          : ScoreboardInstance | any;

    constructor( gameInstance:GameInstance )
    {
        this.gameInstance   = gameInstance;
        this.conquer        = gameInstance.conquer;
        
    }

    public init()
    {
        this.pool           = [];
        this.query          = { gameID:this.gameInstance.gameID };
        
        /*
        for( let n=0; n<scoreboards.length; n++ ) 
        {
            let scoreboardInstance : ScoreboardInstance = new ScoreboardInstance( this.gameInstance, scoreboards[n] );
            this.pool.push( scoreboardInstance );
        } */

        this.get();
    }

    public async get() : Promise<any>
    {
        let query           = this.query;

        query.level         = this.gameInstance.UserXP.level;

        this.pool           = [];

        let scoreboards     = await this.conquer.do( ACTIONS.SCOREBOARD_ENTRIES_GET, query );
  
        for( let n=0; n<scoreboards.length; n++ ) 
        {
            let scoreboardInstance : ScoreboardInstance = new ScoreboardInstance( this.gameInstance, scoreboards[n] );
            this.pool.push( scoreboardInstance );
        } 

        this.refresh();
 
        return Promise.resolve( this.pool );
    }
 
    public async set( score:number )
    {
        if( !score ) return;

        if( this.current ) return this.current.set( score )

        await this.get();

        if( this.current ) return this.current.set( score );
    }

    public remove( scoreboardInstance:ScoreboardInstance )
    {
        ARRAY.removeItem( this.pool, scoreboardInstance );

        this.refresh();
    }

    public refresh() 
    {
        if( !this.pool.length ) return this.get();

        let readyAmount = 0;

        ARRAY.sort( this.pool, "endDate" );

        this.pool.reverse();

        for( let n in this.pool ) if( this.pool[n].endDate < DATE.now() ) readyAmount++;

        this.gameInstance.Signal.set("ScoreboardReady", readyAmount );

        this.current = this.pool[0];
        this.current.get();
    }




 
    /* ============================= 




    LADDER




    ================================ */    
 
    public reset()
    {
        this.ladder = null;
    };

    public async getLadder() : Promise<any>
    {
        if( this.gameInstance.CONFIG.MULTIPLAYER.mode === "Realtime" ) 
        {
            await this.getMultiplayerLadder();
        }else{
            await this.getAsyncLadder();
        } 
 
        return Promise.resolve( this.ladder );
    };

    public async getAsyncLadder() : Promise<any>
    {
        if( this.ladder ) 
        {
            this.sortLadder()
            return Promise.resolve( this.ladder );
        }

        var scorePerMinute      = this.gameInstance.CONFIG.SCORING.scorePerMinute || 100;
        var scoreIncrement      = scorePerMinute / 4;
        var scoreMaxInc         = scorePerMinute * 1.24;
        var score               = 0;

        this.ladderLength       = 30;
 
        // call get Scores from backend
 
        var players : any       = [ this.conquer.Avatars.ME ];
        let self                = this;
        var ladder              = this.ladder = [];

        let array               = await this.conquer.Bots.get( this.ladderLength );

        onScores( array );
 
        Promise.resolve( self.ladder );
 
        function onScores( array:any )
        {
            ARRAY.push( array, players );
 
            for( let n=0; n < self.ladderLength; n++ )
            {
                let player : any    = players[n];
                var vars            = player.vars;
                score               = score + scoreIncrement;
                scoreIncrement      = MATH.clamp( scoreIncrement * 1.1, scoreMaxInc );

                if( player !== self.conquer.Avatars.ME ) vars.score = Math.round( score + RANDOM.value( scoreIncrement * 0.5 ) );
      
                player.score        = vars.score;

                ARRAY.pushUnique( ladder, player );
            }
 
            return self.sortLadder();
        }  
    }

    public getMultiplayerLadder() : Promise<any>
    {
        /*
        ladder = [];
 
        ladderLength = SOCKET.data.players.length;

        for( var n in SOCKET.data.players ) 
        {
            var player = PLAYERS.get( SOCKET.data.players[n] );
            if( player ) ladder.push( player.vars );        
        }

        sortLadder();

        if( ladder[0].avatarID == ME.avatarID ) fire( "WinGames" );

        */

        return Promise.resolve();
    }

    private sortLadder()
    {
        ARRAY.sort( this.ladder, "score" );
        for( let n=0; n < this.ladder.length; n++ ) this.ladder[n].rank = this.ladderLength-n;
        return this.ladder;
    }
 

};

export default Scoreboard;